"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Input = _interopRequireDefault(require("../../elements/input/Input"));

var _inputWithSubmitModule = _interopRequireDefault(require("./input-with-submit.module.scss"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var InputWithSubmit = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(InputWithSubmit, _PureComponent);

  var _super = _createSuper(InputWithSubmit);

  function InputWithSubmit() {
    (0, _classCallCheck2["default"])(this, InputWithSubmit);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(InputWithSubmit, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          submitButton = _this$props.submitButton,
          inputWrapperClassName = _this$props.inputWrapperClassName,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["submitButton", "inputWrapperClassName"]);
      var classes = (0, _classnames["default"])(_inputWithSubmitModule["default"].inputWrapper, inputWrapperClassName);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classes
      }, /*#__PURE__*/_react["default"].createElement(_Input["default"], rest), submitButton);
    }
  }]);
  return InputWithSubmit;
}(_react.PureComponent);

(0, _defineProperty2["default"])(InputWithSubmit, "propTypes", _objectSpread(_objectSpread({}, _Input["default"].propTypes), {}, {
  inputWrapperClassName: _propTypes["default"].string,
  submitButton: _propTypes["default"].node
}));
(0, _defineProperty2["default"])(InputWithSubmit, "defaultProps", _objectSpread(_objectSpread({}, _Input["default"].defaultProps), {}, {
  inputWrapperClassName: '',
  submitButton: undefined
}));
var _default = InputWithSubmit;
exports["default"] = _default;